import getCustomInfoBarViewStates from './infoBarUtils/getCustomInfoBarViewStates';
import getDraftComposeInfoBarViewStates from './infoBarUtils/getDraftComposeInfoBarViewStates';
import getBlockedExternalContentInfoBarViewStatesForCompose from './infoBarUtils/getBlockedExternalContentInfoBarViewStatesForCompose';
import getFullComposeProposedTimeInfoBarMessageViewStates from './infoBarUtils/getFullComposeProposedTimeInfoBarMessageViewStates';
import getGroupCalendarInfoBarViewStates from './infoBarUtils/getGroupCalendarInfoBarViewStates';
import getOutOfBookingWindowInfoBarViewState from './infoBarUtils/getOutOfBookingWindowInfoBarViewState';
import getPublicFolderComposeErrorInfoBarViewStates from './infoBarUtils/getPublicFolderComposeErrorInfoBarViewStates';
import getRecurrenceInfoBarMessageViewStates from './infoBarUtils/getRecurrenceInfoBarMessageViewStates';
import getUntalliedResponsesWarningComposeInfoBarViewStates from './infoBarUtils/getUntalliedResponsesWarningComposeInfoBarViewStates';
import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';
import type { CalendarEvent } from 'owa-calendar-types';
import type { ComposeViewState } from 'owa-calendar-compose-types';
import {
    InfoBarMessageViewState,
    InfoBarMessageSource,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export {
    getDraftComposeInfoBarViewStates,
    getFullComposeProposedTimeInfoBarMessageViewStates,
    getGroupCalendarInfoBarViewStates,
    getPublicFolderComposeErrorInfoBarViewStates,
    getRecurrenceInfoBarMessageViewStates,
    getUntalliedResponsesWarningComposeInfoBarViewStates,
};

/**
 * Returns all the infoBars applicable for the compose form
 * @param event
 * @param originalEvent
 */
const getFullComposeInfoBarMessageViewStates = (
    event: CalendarEvent,
    originalEvent: CalendarEvent,
    viewState?: ComposeViewState
): InfoBarMessageViewState[] => [
    ...getBlockedExternalContentInfoBarViewStatesForCompose(event, viewState),
    ...getPublicFolderComposeErrorInfoBarViewStates(event),
    ...getUntalliedResponsesWarningComposeInfoBarViewStates(event),
    ...getRecurrenceInfoBarMessageViewStates(originalEvent),
    ...getFullComposeProposedTimeInfoBarMessageViewStates(event, originalEvent),
    ...getDraftComposeInfoBarViewStates(originalEvent),
    ...getCustomInfoBarViewStates(getFullComposeViewState(), InfoBarMessageSource.Compose),
    ...getGroupCalendarInfoBarViewStates(originalEvent, event),
    ...getOutOfBookingWindowInfoBarViewState(event),
];

export { getFullComposeInfoBarMessageViewStates };
export { default as getOnlineMeetingInfoBarMessageViewStates } from './infoBarUtils/getOnlineMeetingInfoBarMessageViewStates';
